import React from "react";
import Layout from "../../../components/mobile/Layout/layoutmobileempty";
import "react-multi-carousel/lib/styles.css";
import  CartListMobile  from "../../../components/mobile/CartMobile/cartlist";
import { isAuth } from "../../../helpers/general";
import './css/cart.css';

const Cart=()=> {
if (isAuth === false) {
    window.location.href = '/dang-nhap.html';
}
const handleBack=()=>{
    window.history.back();
}
  return (
   <Layout>
        <CartListMobile key="card-list"/>
   </Layout>
  )
}
export default Cart;